import React, { useState } from "react";
import YearWiseCHWeightChart from "./YearWiseCHWeightChart";

import CHWeightTargetPercentageData from "./CHWeightTargetPercentageData";
import CHWeightSidingWise from "./CHWeightSidingWise";
import SunburstChart from "../../../CHARTS/SunburstChart";
import SunBurst from "./SunBurst";
import SummeryData from "./SummeryData";
import TotalBar from "./TotalBar";
import SevenAMonthwiseReport from "./SevenAMonthwiseReport";
import NoDataFound from "../../../Extra/NoDataFound";
const CHWeight = ({ data, status }) => {
  const [chartData, setChartData] = useState(null);
  const [yearData, setyearData] = useState([]);
  const [targetData, setTargetData] = useState([]);
  const [summery, setSummery] = useState(null);

  const [twoCommodityTargetAchieved, setTwoCommodityTargetAchieved] =
    useState(null);
  return (
    <div className="fade-in-up">
      {" "}
      <h5>7A Loading (CH WEIGHT) </h5>
      <hr className="m-1 " />
      <div>
        <CHWeightTargetPercentageData
          chartData={chartData}
          setTwoCommodityTargetAchieved={setTwoCommodityTargetAchieved}
          yearData={yearData}
          setyearData={setyearData}
        />
      </div>
      <div className="row  d-flex justify-content-center">
        <div className="col-md-8  ">
          <div className="newUiBody">
            {chartData?.series?.length <= 0 ? (
              <b style={{ color: "red" }}>No Data Found !</b>
            ) : null}
            <YearWiseCHWeightChart
              chartData={chartData}
              setTargetData={setTargetData}
              targetData={targetData}
              setSummery={setSummery}
              setCDtoPass
              setChartData={setChartData}
              data={data}
            />
          </div>
        </div>
        <div className="col-md-4  ">
          <div className="newUiBody">
            {data?.length > 0 ? (
              <TotalBar
                status={status}
                targetData={targetData}
                chartData={chartData}
                from={"CHWeight"}
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
        {summery?.commodityWise && (
          <div className="col-md-12">
            <div className="newUiBody">
              <SevenAMonthwiseReport
                status={status}
                from={"chWight"}
                targetData={targetData}
                data={summery.commodityWise}
              />
            </div>
          </div>
        )}
      </div>{" "}
      <div className="row d-flex justify-content-center">
        <div className="col-md-8  ">
          <div className="newUiBody">
            {chartData?.series?.length <= 0 ? (
              <b style={{ color: "red" }}>No Data Found !</b>
            ) : null}
            <CHWeightSidingWise
              chartData={chartData}
              setChartData={setChartData}
              data={data}
            />
          </div>
        </div>
        <div className="col-md-4  ">
          <div className="newUiBody">
            {data?.length > 0 ? (
              <SunBurst data={[data[0]]} keyName={"CH_WEIGHT"} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CHWeight;
